/**
 * O relógio da página principal pública (ORD-F-153, complemento de 20/10 20:40; DECISOES §84): sem sessão nenhuma página
 * consulta o feed, então a contagem e a troca das 17h00 usam o relógio do aparelho, corrigido como no M4 (ORD-F-148)
 * pelo `Date` (+ `Age`) de um pedido pequeno à PRÓPRIA origem: um `HEAD` do HTML de `/`, sem cache, uma vez por carga.
 * Em `src/data`, como todo `fetch` (AC-2.2-01). Nunca lança.
 */

/** Diferença mínima para corrigir o relógio (a mesma `CLOCK_SKEW_MIN_MS` do HttpSource). */
export const ORIGIN_SKEW_MIN_MS = 5_000;

/** A correção (ms) pelo `Date` e o `Age` de uma resposta lida em `localNowMs`; 0 dentro de 5 s ou sem `Date` legível. */
export function originClockOffset(dateHeader: string | null, age: string | null, localNowMs: number): number {
  const ms = dateHeader ? Date.parse(dateHeader) : Number.NaN;
  if (!Number.isFinite(ms)) return 0;
  const ageMs = age !== null && /^\d+$/.test(age.trim()) ? Number(age.trim()) * 1000 : 0;
  const offset = ms + ageMs - localNowMs;
  return Math.abs(offset) > ORIGIN_SKEW_MIN_MS ? offset : 0;
}

/** `HEAD` de `url` (padrão: `/`) sem cache; a correção do relógio do aparelho, ou null em falha. */
export async function fetchOriginClockOffset(
  url = '/',
  fetchImpl: typeof fetch = globalThis.fetch?.bind(globalThis),
  now: () => number = Date.now,
): Promise<number | null> {
  if (!fetchImpl) return null;
  try {
    const sent = now();
    const r = await fetchImpl(url, { method: 'HEAD', cache: 'no-store', credentials: 'omit' });
    // o meio da ida e volta: o `Date` foi carimbado em algum ponto dela
    const local = (sent + now()) / 2;
    return originClockOffset(r.headers.get('Date'), r.headers.get('Age'), local);
  } catch {
    return null;
  }
}
